
import React, {FC} from 'react';
import {BarColors} from 'templates/reports/colors';

import Group from './Group';

import * as styles from './styles.module.scss';

type PercentilesProps = {
	breaks: number[],
	label: string,
	reverse?: boolean,
}

const Percentiles: FC<PercentilesProps> = ({breaks, label, reverse}) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				Percentile groups
			</div>
			<div className={styles.groups}>
				<Group
					color={reverse ? BarColors.red : BarColors.green}
					min={breaks[0]}
					max={breaks[1]}
					text={`Lowest ${label}`}
				/>
				<Group
					color={BarColors.yellow}
					min={breaks[1]}
					max={breaks[2]}
				/>
				<Group
					color={reverse ? BarColors.green : BarColors.red}
					min={breaks[2]}
					max={breaks[3]}
					text={`Highest ${label}`}
				/>
			</div>
		</div>
	);
};

export default Percentiles;
